// ===============================
// Blog auto-linking (Hyper theme)
// - Máx 3 enlaces por post
// - NO duplica URLs destino (ni si ya existían enlaces manuales)
// - Solo se ejecuta en /blogs/
// - NO enlaza dentro de H1-H6
// ===============================

const MAX_LINKS_PER_PAGE = 3;

const AUTO_LINKS = [
  { kw: "aceite de borraja", url: "/collections/aceite-de-borraja" },
  { kw: "aceite de krill", url: "/collections/aceite-de-krill" },
  { kw: "Omega 3 6 9", url: "/collections/pastillas-omega-3-6-9" },
  { kw: "Omega 3", url: "/collections/omegas-aceite-pescado" },
  { kw: "aceite de onagra", url: "/collections/aceite-de-onagra" },
  { kw: "calcio", url: "/collections/calcio" },
  { kw: "colágeno", url: "/collections/colageno" },
  { kw: "anemia", url: "/collections/suplementos-de-hierro-naturales" },
  { kw: "magnesio", url: "/collections/magnesio" },
  { kw: "osteoporosis", url: "/collections/productos-de-herbolario-para-la-osteoporosis" },
  { kw: "antioxidantes naturales", url: "/collections/antioxidantes-naturales" },
  { kw: "coenzima Q10", url: "/collections/coenzima-q10" },
  { kw: "quemagrasas natural", url: "/collections/quemagrasas-natural" },
  { kw: "anticelulíticos", url: "/collections/eliminar-la-celulitis" },
  { kw: "retención de líquidos", url: "/collections/retencion-de-liquidos" },
  { kw: "ciclo menstrual", url: "/collections/ciclos-femeninos" },
  { kw: "energizantes", url: "/collections/energizantes-naturales" },
  { kw: "problemas hepáticos", url: "/collections/protectores-hepaticos" },
  { kw: "problemas de próstata", url: "/collections/prostata" },
  { kw: "relaciones sexuales", url: "/collections/salud-sexual" },
  { kw: "problemas urinarios", url: "/collections/infecciones-urinarias" },
  { kw: "cobre", url: "/collections/cobre" },
  { kw: "fósforo", url: "/collections/fosforo" },
  { kw: "manganeso", url: "/collections/manganeso" },
  { kw: "selenio", url: "/collections/selenio" },
  { kw: "silicio", url: "/collections/silicio" },
  { kw: "yodo", url: "/collections/yodo" },
  { kw: "zinc", url: "/collections/zinc" },
  { kw: "piernas cansadas", url: "/collections/circulacion-piernas" },
  { kw: "hemorroides", url: "/collections/cremas-pomadas-para-las-hemorroides" },
  { kw: "colesterol alto", url: "/collections/colesterol" },
  { kw: "diabetes", url: "/collections/diabetes" },
  { kw: "tensión arterial", url: "/collections/hipertension" },
  { kw: "tension arterial", url: "/collections/hipertension" },
  { kw: "memoria", url: "/collections/memoria" },
  { kw: "erección", url: "/collections/pastillas-herbolario-para-ereccion" },
  { kw: "ácido úrico", url: "/collections/pastillas-naturales-para-bajar-el-acido-urico" },
  { kw: "acidez estomacal", url: "/collections/pastillas-ardor-estomago" },
  { kw: "colon irritable", url: "/collections/productos-de-herbolario-para-colon-irritable" },
  { kw: "detox / depurativo", url: "/collections/detox-depurativos" },
  { kw: "enzimas digestivas", url: "/collections/enzimas-digestivas-naturales" },
  { kw: "flatulencias", url: "/collections/gases-intestinales" },
  { kw: "flora intestinal", url: "/collections/productos-regular-flora-intestinal" },
  { kw: "laxantes", url: "/collections/laxantes-naturales" },
  { kw: "probióticos", url: "/collections/probioticos-prebioticos" },
  { kw: "tránsito intestinal", url: "/collections/regular-transito-intestinal" },
  { kw: "alergias", url: "/collections/alergia" },
  { kw: "dolor de garganta", url: "/collections/dolor-de-garganta" },
  { kw: "jalea real", url: "/collections/jalea-real" },
  { kw: "tos seca", url: "/collections/remedios-tos" },
  { kw: "propóleo", url: "/collections/propoleo-natural" },
  { kw: "propoleo", url: "/collections/propoleo-natural" },
  { kw: "insomnio", url: "/collections/insomnio" },
  { kw: "dolor de cabeza", url: "/collections/pastillas-naturales-para-el-dolor-de-cabeza" },
  { kw: "cansancio", url: "/collections/pastillas-naturales-para-el-cansancio" },
  { kw: "Vitamina A", url: "/collections/vitamina-a" },
  { kw: "Vitamina B", url: "/collections/vitamina-b" },
  { kw: "Vitamina C", url: "/collections/vitamina-c" },
  { kw: "Vitamina D", url: "/collections/vitamina-d" },
  { kw: "Vitamina E", url: "/collections/vitamina-e" },
  { kw: "Vitamina K2", url: "/collections/vitamina-k2" },
  { kw: "Vitamina K", url: "/collections/comprar-vitamina-k" },
];

(function () {
  const EXCLUDE =
    "a, button, nav, header, footer, script, style, h1, h2, h3, h4, h5, h6";

  const escapeRegex = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  function makeRe(kw) {
    const k = escapeRegex(String(kw).trim());
    return new RegExp(
      `(^|[\\s\\(\\[\\{\"'¿¡,.:;!\\?\\-])(${k})(?=$|[\\s\\)\\]\\}\"',.:;!\\?\\-])`,
      "i"
    );
  }

  function isBlogPost() {
    return location.pathname.includes("/blogs/");
  }

  function pickBestContainer() {
    const root = document.querySelector("main") || document.body;
    const candidates = [
      ...root.querySelectorAll(
        ".prose, .rte, .article__content, .article-content, .blog-post__content, .blog-post__text, article"
      ),
    ];

    let best = null;
    let bestLen = 0;

    for (const el of candidates) {
      const t = (el.innerText || "").trim();
      if (t.length > bestLen) {
        bestLen = t.length;
        best = el;
      }
    }
    return best || root;
  }

  // Normaliza a “pathname” sin dominio, y sin trailing slash
  function normalizeHref(href) {
    try {
      const u = new URL(href, location.origin);
      let p = u.pathname || "";
      if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
      return p;
    } catch (e) {
      return null;
    }
  }

  // Precarga URLs ya enlazadas (manuales) para NO duplicar
  function preloadUsedUrls(container) {
    const used = new Set();
    const links = container.querySelectorAll("a[href]");
    links.forEach((a) => {
      const p = normalizeHref(a.getAttribute("href"));
      if (p) used.add(p);
    });
    return used;
  }

  function buildIndex(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let full = "";
    let n;

    while ((n = walker.nextNode())) {
      const parent = n.parentElement;
      if (!parent) continue;
      if (parent.closest(EXCLUDE)) continue;

      const text = n.nodeValue || "";
      if (!text) continue;

      nodes.push({ node: n, start: full.length, end: full.length + text.length });
      full += text;
    }

    return { nodes, full };
  }

  function idxToPos(nodes, idx) {
    for (const item of nodes) {
      if (idx >= item.start && idx <= item.end) {
        return { node: item.node, offset: idx - item.start };
      }
    }
    return null;
  }

  function intersectsLink(range) {
    const common =
      range.commonAncestorContainer.nodeType === 1
        ? range.commonAncestorContainer
        : range.commonAncestorContainer.parentElement;
    if (!common) return false;
    return !!common.closest("a");
  }

  function run() {
    if (!isBlogPost()) return;

    const container = pickBestContainer();
    if (!container) return;

    // Importante: normalizamos URLs objetivo igual que las existentes
    const targetItems = [...AUTO_LINKS]
      .map((x) => ({
        kw: x.kw,
        url: x.url,
        urlNorm: normalizeHref(x.url) || x.url,
      }))
      .sort((a, b) => (b.kw || "").length - (a.kw || "").length);

    let linked = 0;

    // Aquí está la clave: si ya había enlaces manuales, los respetamos
    const usedUrls = preloadUsedUrls(container);

    while (linked < MAX_LINKS_PER_PAGE) {
      const { nodes, full } = buildIndex(container);
      let inserted = false;

      for (const item of targetItems) {
        if (linked >= MAX_LINKS_PER_PAGE) break;
        if (!item.kw || !item.url) continue;

        // Si la URL ya existe (manual o auto), NO ponemos otro enlace
        if (usedUrls.has(item.urlNorm)) continue;

        const re = makeRe(item.kw);
        const m = re.exec(full);
        if (!m) continue;

        const startIdx = m.index + (m[1] ? m[1].length : 0);
        const endIdx = startIdx + m[2].length;

        const startPos = idxToPos(nodes, startIdx);
        const endPos = idxToPos(nodes, endIdx);
        if (!startPos || !endPos) continue;

        const range = document.createRange();
        range.setStart(startPos.node, startPos.offset);
        range.setEnd(endPos.node, endPos.offset);

        if (intersectsLink(range)) continue;

        const a = document.createElement("a");
        a.href = item.url;
        a.appendChild(range.extractContents());
        range.insertNode(a);

        usedUrls.add(item.urlNorm);
        linked += 1;
        inserted = true;
        break;
      }

      if (!inserted) break;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();